import { Decoration_Type } from 'ricos-schema';

const DECORATION_LINK_MODAL_ID = `${Decoration_Type.LINK}.decoration.modal`;
const NODE_LINK_SETTINGS_MODAL_ID = `${Decoration_Type.LINK}.node.modal`;
const LINK_TYPE = {
  LINK: "link",
  ANCHOR: "anchor"
};

export { DECORATION_LINK_MODAL_ID, LINK_TYPE, NODE_LINK_SETTINGS_MODAL_ID };
//# sourceMappingURL=constants.js.map
